import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
export function ClaridadSection() {
  const [ref, isInView] = useInView({
    threshold: 0.2
  });
  return <section className="py-16 sm:py-32 relative overflow-hidden bg-[#0A0A0B] border-t border-white/5" data-id="element-125">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center relative z-10" data-id="element-126">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8
      }} data-id="element-127">
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-black text-white mb-8 leading-tight" data-id="element-128">
            El problema <span className="text-gold" data-id="element-129">nunca fuiste tú.</span>
          </h2>

          <div className="space-y-6 text-lg sm:text-xl text-white/80 font-medium leading-relaxed" data-id="element-130">
            <p data-id="element-131">
              Fueron los patrones emocionales y la forma en que aprendiste a
              relacionarte con tu enfoque, tu calma y tu presencia.
            </p>
            <p data-id="element-132">
              Con el tiempo, sin darte cuenta, tu mente aprendió a operar desde
              el ruido, la prisa y la falta de espacio interior.
            </p>
            <p className="text-white font-bold mt-8" data-id="element-133">
              Y mientras no crees momentos reales de pausa, ese ruido sigue
              dirigiendo cómo piensas, decides y sientes.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}